<template>
  <div>
    <loading-page title="Redirecionando..." />
    <form
      v-if="concursos"
      method="POST"
      :action="concursos.url"
      class="c-d-none"
      ref="formConcursos"
    >
      <input
        type="hidden"
        name="access_token"
        :value="concursos.token"
      >
    </form>
  </div>
</template>

<script>
import LoadingPage from '@/components/loading-page';
import { getToken } from '@/services/token';
import { isTargetFromConcursos, isTargetFromSomeAllowedHosts, getTargetFromUrl } from '@/utils/url';

export default {
  components: { LoadingPage },
  data() {
    return {
      concursos: null,
    };
  },
  mounted() {
    this.followRedirect();
  },
  methods: {
    followRedirect() {
      const target = getTargetFromUrl();

      if (!target) {
        return this.$router.push('/');
      }

      if (isTargetFromConcursos(target)) {
        this.concursos = { url: target, token: getToken() };
        this.$nextTick(() => this.$refs.formConcursos.submit());
        return;
      }

      const allowedTargetHosts = this.$env.VUE_APP_ALLOWED_TARGET_HOSTS.split(',');
      if (isTargetFromSomeAllowedHosts(target, allowedTargetHosts)) {
        location.href = target;
        return;
      }

      return this.$router.push('/');
    },
  },
};
</script>
